import { useMutation, useQuery } from "@tanstack/react-query";
import { getPaymentChannels, queryPayment } from "../../requests";
import { Field, FormikProvider, useFormik } from "formik";
import Input from "../../custom/input/input";
import { Alert, App, Card } from "antd";
import { errorMessage } from "../../utils/errorMessage";
import Button from "../../custom/button/button";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import Select from "../../custom/select/select";
import { object, string } from "yup";

const QueryTransaction = () => {
  const { notification } = App.useApp();
  const [response, setResponse] = useState({
    type: "",
    status: "",
    description: "",
  });

  const { data, isLoading } = useQuery({
    queryKey: ["get-payment-channels"],
    queryFn: getPaymentChannels,
  });

  const queryPaymentMutation = useMutation({
    mutationKey: ["queryPayment"],
    mutationFn: queryPayment,
  });

  const channels = data?.Data as PaymentChannelOptions[];
  const channelOptions = channels?.map((channel) => (
    <option key={channel.Name}>{channel.Name}</option>
  ));

  const validationSchema = object({
    transactionReference: string().required(
      "Transaction reference is required"
    ),
    channel: string().required("Payment channel is required"),
  });

  const formik = useFormik({
    initialValues: {
      transactionReference: "",
      channel: "Cyberpay",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { transactionReference, channel } = values;
      try {
        await queryPaymentMutation.mutateAsync(
          {
            reference: transactionReference,
            paymentChannel: channel,
          },
          {
            onSuccess: (data) => {
              notification.success({
                message: data.message,
                description: `Transaction ID: ${data.transactionReference}`,
              });
              setResponse({
                type: "success",
                status: data.transactionStatus,
                description: `Reference: ${data.transactionReference}`,
              });
            },
          }
        );
      } catch (error: any) {
        notification.error({
          message: errorMessage(error),
        });
        setResponse({
          type: "error",
          status: "Failed",
          description: error?.response?.data?.message,
        });
      }
    },
  });

  useEffect(() => {
    // Use setTimeout to update the message after 2000 milliseconds (2 seconds)
    const timeoutId = setTimeout(() => {
      setResponse({
        type: "",
        status: "",
        description: "",
      });
    }, 5000);

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timeoutId);
  }, [queryPaymentMutation.data]); // Empty dependency array ensures the effect runs only once

  return (
    <FormikProvider value={formik}>
      <h3>Check transaction status</h3>
      <br />
      <Card>
        <form onSubmit={formik.handleSubmit}>
          <Field
            name="transactionReference"
            as={Input}
            label="Transaction Reference"
            placeholder="ABC112233445566777889"
            className={styles.inputField}
          />
          <br />
          <Field
            name="channel"
            as={Select}
            label="Payment Channel"
            placeholder="Select Payment Channel"
            options={channelOptions}
            className={styles.inputField}
            isLoading={isLoading}
          />
          <br />

          <Button
            type="submit"
            disabled={queryPaymentMutation.isPending}
            isLoading={queryPaymentMutation.isPending}
            text="Check Status"
          />
        </form>
        <br />
        {!!response.status && (
          <Alert
            message={response.status}
            description={response.description}
            type={response.type === "success" ? "success" : "error"}
            showIcon
            closable
          />
        )}
      </Card>
    </FormikProvider>
  );
};

export default QueryTransaction;
